import { useEffect, useState } from "react";
import styles from "./statistic.module.css";
import StatisticFormat from "components/statisticFormat/statisticFormat";
import { statistic7 } from "services/statistic/statistic7";
import { downloadFile, generateCSVContent, months } from "utils/statistic";
import { BlockmonthData } from "modules/statistic";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import Popup from "components/Popup/popup";
import ErrorFailed from "components/errorFailed/errorFailed";
import React from "react";


export default function Statistic7() {
  const [blockData, setBlockData] = useState<BlockmonthData>({});
  const [blocks, setBlocks] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minYear, setMinYear] = useState<number | null>(null);
  const [maxYear, setMaxYear] = useState<number | null>(null);
  const fetchData = async () => {
    try {
      const res = await statistic7(startDate, endDate);
      const { data, blocks, years } = res;
      setBlockData(data);
      setBlocks(blocks);
      setMinYear(Math.min(...years));
      setMaxYear(Math.max(...years));
    } catch (error) {
      console.error("Fehler beim Laden der Daten:", error);
    }
  };

  const handleFilter = () => {
    if (!startDate || !endDate) {
      setError("Bitte geben Sie sowohl ein Startdatum als auch ein Enddatum ein.");
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      setError("Das Startdatum kann nicht nach dem Enddatum liegen.");
      return;
    }

    setIsPopupOpen(false);
    setError(null);
    setIsPopupOpen(false);
    fetchData();
  };

  const handleDeleteFilter = () => {
    setStartDate('');
    setEndDate('');
    setError(null)
    setIsPopupOpen(false);
  };


  const downloadCSV = () => {
    const headers = [
      'Monat/Jahr',
      ...blocks.map((block) => `Block ${block}`),
      'Gesamt'
    ];

    const rows: (string | number)[][] = [];

    months.forEach((month, monthIndex) => {
      const yearsData = blockData[month] || {};
      const allYears = Object.keys(yearsData).sort((a, b) => Number(b) - Number(a));

      allYears.forEach((year) => {
        const yearData = yearsData[year];
        const row = [
          `${month} ${year}`,
          ...blocks.map((block) => {
            const blockDataForYear = yearData.blocks.find((b) => b.block === block);
            return blockDataForYear ? blockDataForYear.total_bookings : 0;
          }),
          yearData.total
        ];
        rows.push(row);
      });
    });

    const csvContent = generateCSVContent(headers, rows);
    downloadFile(csvContent, "Anlage4.csv");
  };

  useEffect(() => {
    fetchData();
  }, [isPopupOpen]);

  return (
    <>
      <StatisticFormat
        label="Anlage 4"
        description={startDate && endDate
          ? `Belegungszahlen der "Flexi" im Zeitraum vom ${startDate} bis ${endDate} Anzahl der Buchungen je Block und Monat (Montag bis Freitag).`
          : `Belegungszahlen der "Flexi" im Zeitraum vom 01.01.${minYear} bis 31.12.${maxYear} Anzahl der Buchungen je Block und Monat (Montag bis Freitag).`
        }
        onFilterButton1Click={() => setIsPopupOpen(true)}
        onButton1Click={downloadCSV}
      >
        <div className={styles.container}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Monat/Jahr</th>
                {blocks.map((block) => (
                  <th key={`block-${block}-header`}>Block {block}</th>
                ))}
                <th className={styles.gesamt}>Gesamt</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.emptyRowNoBorder}>
                <td colSpan={blocks.length + 2}></td>
              </tr>

              {months.map((month, monthIndex) => {
                const yearsData = blockData[month] || {};
                const allYears = Object.keys(yearsData).sort((a, b) => Number(b) - Number(a));
                const currentYear = Math.max(...Object.keys(yearsData).map(Number));

                const rows = allYears.filter((year) => year).map((year, index) => {
                  const yearData = yearsData[year];
                  return (
                    <tr key={`${month}-${year}-${index}`} className={styles[`year-${(currentYear - parseInt(year)) % 9 + 1}`]}>
                      <td>{month} {year}</td>

                      {blocks.map((block) => {
                        const blockDataForYear = yearData.blocks.find((b) => b.block === block);
                        return (
                          <td key={`${month}-${year}-${block}-total`}>
                            {blockDataForYear ? blockDataForYear.total_bookings : 0}
                          </td>
                        );
                      })}

                      <td>{yearData.total}</td>
                    </tr>
                  );
                });

                return (
                  <React.Fragment key={`${month}-${monthIndex}`}>
                    {rows}
                    <tr className={styles.emptyRow}>
                      {Array.from({ length: blocks.length + 2 }).map((_, index) => (
                        <td key={`empty-cell-${index}`}></td>
                      ))}
                    </tr>
                  </React.Fragment>
                );
              })}

            </tbody>
          </table>
        </div>
      </StatisticFormat>
      <Popup
        title={'Filter'}
        submitLabel={"Einsetzen"}
        closeLabel={"Zurücksetzen"}
        isWithButton={true}
        isOpen={isPopupOpen}
        onClose={handleDeleteFilter} onSubmit={handleFilter}>
        {error && <ErrorFailed error={error} />}

        <div className={commonStyles.formGroupRow}>
          <div className={commonStyles.formGroup}>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className={commonStyles.formGroup}>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </Popup>

    </>
  );

}
